var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPowerPlug = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 348,
    viewBox: "0 0 618 348",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.235 150.98H222.182V167.701H230.235V150.98Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.032 187.685H250.051C238.152 187.685 228.516 178.034 228.516 166.116V152.659C228.516 140.741 238.152 131.09 250.051 131.09H283.032C286.787 131.09 289.818 134.126 289.818 137.887V180.934C289.818 184.649 286.741 187.685 283.032 187.685Z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.762 139.971H270.229V179.936H272.762V139.971Z",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.735 139.971H266.201V179.936H268.735V139.971Z",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.662 139.971H262.129V179.936H264.662V139.971Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.761 196.204C279.006 196.204 275.975 193.168 275.975 189.407V129.322C275.975 125.561 279.006 122.525 282.761 122.525C286.516 122.525 289.547 125.561 289.547 129.322V189.407C289.547 193.168 286.516 196.204 282.761 196.204Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.209 159.363C213.767 158.185 203.588 166.795 197.661 176.99C190.92 188.635 189.88 202.501 185.491 215.007C183.456 220.852 180.47 226.698 175.538 230.368C169.34 234.99 161.106 235.579 153.37 235.534C148.167 235.488 142.919 235.216 137.897 233.812C132.876 232.407 128.08 229.734 124.913 225.61C121.203 220.852 119.936 214.645 118.217 208.845C109.033 177.67 83.9694 154.923 53.748 144.546C53.1599 144.365 52.5717 144.138 51.9836 143.957C49.4048 143.096 46.8713 142.326 44.2925 141.555C43.9306 141.465 43.5687 141.329 43.2067 141.238C42.2567 140.966 41.3066 140.695 40.3113 140.423C39.6326 140.241 38.954 140.06 38.2754 139.879",
    stroke: "#747474",
    strokeWidth: 15,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347.909 164.621C347.321 166.207 345.556 166.977 343.973 166.388L314.747 155.151C313.163 154.562 312.394 152.795 312.982 151.209C313.57 149.623 315.335 148.852 316.918 149.442L346.144 160.679C347.728 161.313 348.497 163.081 347.909 164.621Z",
    fill: "#C2C2C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.141 193.846C336.553 195.432 334.788 196.202 333.205 195.613L304.024 184.331C302.441 183.742 301.671 181.974 302.26 180.388C302.848 178.802 304.612 178.032 306.196 178.621L335.422 189.859C336.96 190.538 337.774 192.26 337.141 193.846Z",
    fill: "#C2C2C2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.115 205.563L393.627 208.469L399.642 192.872L392.13 189.966L386.115 205.563Z",
    fill: "#747474"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M350.034 152.296L380.798 164.213C391.882 168.518 397.402 180.979 393.149 192.126L388.308 204.723C384.01 215.824 371.569 221.352 360.439 217.093L329.675 205.176C326.192 203.817 324.427 199.874 325.784 196.385L341.257 156.238C342.614 152.704 346.55 150.937 350.034 152.296Z",
    fill: "#B3B3B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M342.455 200.49L344.818 201.404L359.195 164.124L356.832 163.21L342.455 200.49Z",
    fill: "#747474"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.234 201.961L348.598 202.875L362.975 165.595L360.611 164.681L346.234 201.961Z",
    fill: "#747474"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M350.014 203.431L352.377 204.346L366.754 167.066L364.391 166.152L350.014 203.431Z",
    fill: "#747474"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M353.337 144.457C356.821 145.816 358.585 149.758 357.228 153.247L335.602 209.299C334.245 212.788 330.309 214.555 326.826 213.196C323.342 211.836 321.577 207.894 322.935 204.405L344.56 148.353C345.917 144.819 349.853 143.097 353.337 144.457Z",
    fill: "#747474"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M392.832 199.193C404.007 204.766 416.629 200.416 425.813 193.031C436.309 184.602 442.236 172.051 450.832 161.946C454.858 157.234 459.699 152.838 465.671 151.207C473.091 149.123 481.008 151.57 488.201 154.424C493.042 156.327 497.838 158.502 502 161.629C506.162 164.756 509.691 168.97 511.184 173.954C512.948 179.754 511.863 185.962 511.365 191.988C508.741 224.387 523.897 254.656 548.373 275.227C548.825 275.635 549.323 275.998 549.775 276.406C551.856 278.127 553.982 279.804 556.109 281.435C556.426 281.662 556.697 281.888 557.014 282.16C557.828 282.749 558.597 283.384 559.411 283.973C560 284.381 560.543 284.834 561.131 285.241",
    stroke: "#747474",
    strokeWidth: 15,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPowerPlug, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/powerPlug.54c29565.svg";
export { ForwardRef as ReactComponent };